import React from "react";

import Paper from "@mui/material/Paper";

import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import TabList from "@mui/lab/TabList";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";

import SvgIconStyle from "../../../components/SvgIconStyle";

import { useDispatch } from "react-redux";

import { adminDashboardMenu, organizationDashboardMenu } from "../../../data";

import { paperStyles, tabStyles, paperOrganizationStyles } from "./styles";
import { ComponentType } from "../../../common/enum";
import { setOrganizationDashboardTab } from "../adminSlice";
import { Box } from "@mui/material";

const AdminSideNavbar = ({ t, component }) => {
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.up("md"));

  const dispatch = useDispatch();

  const handleTabChange = React.useCallback(
    (event, newValue) => {
      if (component === ComponentType.ADMIN_VIEW) {
        dispatch(setAdminDashboardTab(newValue));
      } else if (component === ComponentType.ORGANIZATIONS) {
        dispatch(setOrganizationDashboardTab(newValue));
      }
    },
    [dispatch]
  );

  const orientation = React.useMemo(() => {
    if (component === ComponentType.ADMIN_VIEW && matches) {
      return "vertical";
    }
    return "horizontal";
  }, [matches, component]);

  const menu = React.useMemo(() => {
    if (component === ComponentType.ORGANIZATIONS) {
      return organizationDashboardMenu;
    }
    return adminDashboardMenu;
  }, [component, ComponentType]);

  return (
    <Paper
      sx={
        component === ComponentType.ADMIN_VIEW
          ? paperStyles
          : paperOrganizationStyles
      }
    >
      <TabList
        aria-label="lab API tabs example"
        onChange={handleTabChange}
        orientation={orientation}
        variant="scrollable"
        scrollButtons="auto"
        allowScrollButtonsMobile
      >
        {menu?.map((item, i) => (
          <Tab
            sx={tabStyles}
            icon={
              component === ComponentType.ADMIN_VIEW && (
                <SvgIconStyle
                  src={item.icon}
                  sx={{ [theme.breakpoints.up("md")]: { mr: "20px" } }}
                />
              )
            }
            label={
              <h2
                style={{
                  fontWeight: "bold",
                  fontSize: component === ComponentType.ADMIN_VIEW ? 20 : 14,
                  marginBottom: "0px"
                }}
              >
                {t(`${item.title}`)}
              </h2>
            }
            iconPosition={matches ? "start" : "top"}
            value={item.title}
            key={i}
          />
        ))}
      </TabList>
    </Paper>
  );
};

export default AdminSideNavbar;
